import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
//, Thumbs,Scrollbar

jQuery(($) => {
	let initialGallerySlider = 0;
	/* if ($(".swiper-gallery .swiper-slide").length > 0) {
		const totalSlides = $(".swiper-gallery .swiper-slide").length;
		initialGallerySlider = roundUp(totalSlides / 2, 1);
	} */

	new Swiper(".swiper-gallery", {
		slidesPerView: "auto",
		spaceBetween: 30,
		loop: false,
		centeredSlides: true,
		initialSlide: 1,
		navigation: {
			nextEl: ".swiper-button-next-gallery-slider",
			prevEl: ".swiper-button-prev-gallery-slider",
		},
		/* scrollbar: {
			el: ".swiper-scrollbar-gallery-slider",
			draggable: true,
		}, */
		pagination: {
			el: ".swiper-pagination-gallery-slider",
			dynamicBullets: true,
			clickable: true,
		},
		modules: [Navigation, Pagination], //Scrollbar,
		breakpoints: {
			1024: {
				spaceBetween: 30,
			},
			767: {
				spaceBetween: 15,
			},
			0: {
				spaceBetween: 9,
			},
		},
	});
});
